import { combineReducers } from 'redux'

import availableDates from './availableDates/reducer'

export default combineReducers({
  availableDates,
})
